import axios from "axios";
const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;


const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Function to handle GET requests
async function get(endpoint, params = {}) {
  try {
    const response = await api.get(endpoint, { params });
    return response.data; // Return only the data
  } catch (error) {
    console.error("Error fetching data:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
}

// Function to handle POST requests
// async function post(endpoint, body, isMultipart = false) {
//   try {
//     const headers = isMultipart ? {} : { "Content-Type": "application/json" };
//     const response = await api.post(endpoint, body, { headers });
//     return response.data; // Return only the data
//   } catch (error) {
//     console.error("Error posting data:", error.response?.data || error.message);
//     throw error.response?.data || error;
//   }
// }

async function post(endpoint, body, isMultipart = false) {
  const url = `${BASE_URL}/${endpoint}`;
  const headers = {};

  // Only set Content-Type for non-multipart data
  if (!isMultipart) {
    headers['Content-Type'] = 'application/json';
  }

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers,
      body: isMultipart ? body : JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error posting data:', error.message);
    throw new Error(error);
  }
}

// Function to handle DELETE requests
async function del(endpoint) {
  try {
    const response = await api.delete(endpoint);
    return response.data; // Return only the data
  } catch (error) {
    console.error("Error deleting data:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
}

export { get, post, del };
